import PlannedTime from "./PlannedTime.js";

class PlannedTimeRepository {

    /**
     * @abstract
     * @param {Date} start
     * @param {Date} end
     * @return {Promise<PlannedTime[]>}
     */
    async getDuring(start, end) {

    }

}

export default PlannedTimeRepository;